import { Image } from 'src/app/people/models/image';

export class AutoCompletePersonModel {
  id: string;
  fullName: string;
  email: string;
  imageId?: string;
  image?: Image;

  constructor(id: string, fullName: string, email: string, imageId?: string) {
    this.id = id;
    this.fullName = fullName;
    this.email = email;
    this.imageId = imageId;
    this.image = imageId ? new Image(imageId) : null;
  }

  static parse(data: any): AutoCompletePersonModel {
    return new AutoCompletePersonModel(data.id, data.fullName, data.email, data.imageId);
  }
}
